import IconButton from '@/global/components/Button/IconButton'
import { optionsColumn } from '@/global/components/DataGrid/hooks/useDataGridPro'
import { SelectEmpresa } from 'global/components/Selects'
import ContentGuide from 'global/guides/ContentGuide'
import { hasPermission } from 'hooks/useBackendMenu'
import { PencilIcon, Trash2Icon, UserRoundPenIcon } from 'lucide-react'
import { Outlet, useOutletContext } from 'react-router-dom'
import { type Reps, reps } from 'service/api'
import { useStore } from 'store'

export default function Reps() {
    const empresaId = useStore(state => state.companyId)
    const { data, isLoading } = reps.useFetch({
        queryParams: {
            empresaId,
        },
    })

    return (
        <ContentGuide>
            <ContentGuide.Card>
                <ContentGuide.Header label={['Integrações', 'REPs']}>
                    <SelectEmpresa hideWhenSingle />
                </ContentGuide.Header>
                <ContentGuide.DataGrid
                    loading={isLoading}
                    onAdd
                    columns={[
                        {
                            field: 'nome',
                            headerName: 'Nome do REP',
                            flex: 1,
                        },
                        {
                            field: 'Marca',
                            headerName: 'Marca',
                            flex: 0.8,
                            valueGetter: param => param.value.nome,
                        },
                        {
                            field: 'ultimoNsr',
                            headerName: 'Último NSR',
                            width: 160,
                            type: 'number',
                        },
                        {
                            field: 'usuario',
                            headerName: 'Usuário',
                            width: 160,
                        },
                        {
                            field: 'ip',
                            headerName: 'IP',
                            width: 140,
                        },
                        {
                            field: 'porta',
                            headerName: 'Porta',
                            width: 80,
                            type: 'number',
                        },
                        {
                            ...optionsColumn,
                            field: '__associar',
                            renderCell: ({ id }) =>
                                hasPermission(['update', 'Reps'], () => (
                                    <IconButton
                                        title="Associar Funcionários"
                                        href={`${id}/associar`}
                                    >
                                        <UserRoundPenIcon />
                                    </IconButton>
                                )),
                        },
                        {
                            ...optionsColumn,
                            field: '__editar',
                            renderCell: ({ id }) =>
                                hasPermission(['update', 'Reps'], () => (
                                    <IconButton
                                        title="Editar"
                                        href={`${id}/editar`}
                                    >
                                        <PencilIcon />
                                    </IconButton>
                                )),
                        },
                        {
                            ...optionsColumn,
                            field: '__excluir',
                            renderCell: ({ id }) =>
                                hasPermission(['delete', 'Reps'], () => (
                                    <IconButton
                                        title="Excluir"
                                        href={`${id}/excluir`}
                                    >
                                        <Trash2Icon className="text-error" />
                                    </IconButton>
                                )),
                        },
                    ]}
                    ToolbarProps={{
                        exportButtonProps: {
                            fileName: 'exportacao-reps',
                        },
                    }}
                    rows={data}
                />
            </ContentGuide.Card>
            <Outlet context={{ data }} />
        </ContentGuide>
    )
}

export function useRepsOutletContext() {
    return useOutletContext<{
        data?: Reps[]
    }>()
}
